import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ImageBlockBenin,
  imageBlocksBenin,
} from 'src/app/modules/shared/interfaces/ImageBlockBenin';

@Component({
  selector: 'app-portailappelform',
  templateUrl: './portailappelform.component.html',
  styleUrls: ['./portailappelform.component.css'],
})
export class PortailappelformComponent implements OnInit {
  paramValue?: string;
  pays?: string;
  imageBlocks: ImageBlockBenin[] = imageBlocksBenin;

  constructor(
    private router: Router,
    private activated: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.activated.paramMap.subscribe((params) => {
      this.paramValue = params.get('params') || '';
      this.pays = params.get('pays') || '';
      console.log(this.pays);
    });
  }

  // goFormation() {
  //   window.location.href =
  //     'http://localhost:4200/#/horsigui/fode/candidature/HSIG2510-BENIN/' +
  //     this.paramValue;
  // }

  goFormation() {
    if (this.paramValue === 'BLOLAB') {
      this.router.navigate([
        '/horsigui/fode/candidature/BENIN-BLOLAB-HSIG2607',
        'BLOLAB',
      ]);
    } else {
      this.router.navigate([
        '/horsigui/fode/candidature/BENIN-BATONGA-HSIG2610',
        this.paramValue,
      ]);
    }
  }

  // goEntreprenariat() {
  //   window.location.href =
  //     'http://localhost:4200/#/horsigui/fode/candidature/MAE2509-FODE/FODE';
  // }
  goEntreprenariat() {
    if (this.paramValue === 'BLOLAB') {
      this.router.navigate([
        '/horsigui/fode/candidature/BENIN-BLOLAB-MAE2607/BLOLAB',
      ]);
    } else {
      this.router.navigate([
        '/horsigui/fode/candidature/BENIN-BATONGA-MAE2610/BATONGA',
      ]);
    }
  }
}
